export default __webpack_public_path__ + "static/rovo-thinking-skeleton-dark-04dc76e947cb02393969f52845144337.png";